"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInsightCategory = void 0;
const InsightCategory_1 = require("../entity/InsightCategory");
const insightArticle_1 = require("./insightArticle");
const createInsightCategory = ({ id = 'test', name = 'test', pcColumnCount = 1, spColumnCount = 1, rowCount = 1, articles = [insightArticle_1.createInsightArticle()], } = {}) => InsightCategory_1.default.fromJSON({
    id,
    name,
    pcColumnCount,
    spColumnCount,
    rowCount,
    articles,
});
exports.createInsightCategory = createInsightCategory;
